import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BudgetControlItemService } from '@/core/services/budget-control-item.service';
import {
  loadBudgetControlItemsByProject,
  loadBudgetControlItemsByProjectSuccess,
  loadBudgetControlItemsByProjectFailure,
} from './budget-control-item.actions';

@Injectable()
export class BudgetControlItemEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(BudgetControlItemService);

  loadByProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBudgetControlItemsByProject),
      switchMap(({ projectId }) =>
        this.service.getByProjectId(projectId).pipe(
          map((items) => loadBudgetControlItemsByProjectSuccess({ items, projectId })),
          catchError((error) => of(loadBudgetControlItemsByProjectFailure({ error })))
        )
      )
    )
  );
}
